// ProjectTaskStatus is not needed - ProjectTask uses TaskStatus from this file

export type ViewState = string;

export enum UserRole {
  ADMIN = 'ADMIN',
  /** Cross-tenant platform operator (prefer over generic ADMIN for new code). */
  PLATFORM_ADMIN = 'PLATFORM_ADMIN',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  TENANT = 'TENANT',
  OWNER = 'OWNER',
  INVESTOR = 'INVESTOR',
  VENDOR = 'VENDOR',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN'
}

/**
 * Base entity interface for soft delete support
 * All entities should extend this to support audit trails and data recovery
 */
export interface BaseEntity {
  id: string;
  deletedAt?: string;
  deletedBy?: string;
}

/**
 * Task Status
 * Represents the current state of a task
 */
export type TaskStatus = 'Open' | 'Pending' | 'In Progress' | 'Completed';

/**
 * Task Priority
 * Represents the priority level of a task
 */
export type TaskPriority = 'Low' | 'Medium' | 'High' | 'Critical';

/**
 * Task Type
 * Represents the category/type of a task
 */
export type TaskType = 'Maintenance' | 'Leasing' | 'Administrative';

/**
 * Task Interface
 * Represents a general task (not project-specific)
 * Project tasks use ProjectTask from types/projects
 */
export interface Task {
  id: string;
  title: string;
  description: string;
  status: TaskStatus;
  priority: TaskPriority;
  due: string;
  /** UserProfile id when assigned; prefer this over legacy `assignee` text. */
  assigneeId?: string | null;
  /** Denormalized display name (from assignee user); API may omit when unassigned. */
  assignee?: string;
  propertyId?: string;
  type: TaskType;
}

/**
 * Task Input for Creation
 * Task without id (for create operations)
 */
export type CreateTaskInput = Omit<Task, 'id'>;

/**
 * Task Update Input
 * Partial task fields for update operations
 */
export type UpdateTaskInput = Partial<Omit<Task, 'id'>>;
